<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> حساب های دارای گردش
      <v-spacer></v-spacer>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <a v-bind="attrs" v-on="on" id="AccountsBtnDownload" download="accounts_chart.png" href="">
            <v-btn fab icon>
              <v-img class="" src="/img/icons/chart_download.svg" max-width="21"></v-img>
            </v-btn>
          </a>
        </template>
        دریافت نمودار
      </v-tooltip>
    </v-card-title>
    <canvas id="accounts-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import accountsData from "@/views/modulePages/accountingModule/accounts-data";

export default {
  name: 'accountsChart',
  data() {
    return {
      chartData: accountsData
    }
  },
  mounted() {
    const ctx = document.getElementById('accounts-chart');
    new Chart(ctx, this.chartData);
    document.getElementById("AccountsBtnDownload").addEventListener('click', function () {
      var base64_url = document.getElementById("accounts-chart").toDataURL("image/png");
      this.href = base64_url;
    });

  }
}
</script>